module.exports = __webpack_public_path__ + "img/en.8b3245f2.png";